'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var initAction = { type: '@@multireducer/INIT' };

exports.default = initAction;


//////////////////
// WEBPACK FOOTER
// ./~/multireducer/lib/initAction.js
// module id = 1550
// module chunks = 1 2 3